/**
 * TaskFormActions Component
 *
 * Handles form action buttons:
 * - Create more tasks checkbox
 * - Back button
 * - Submit button
 *
 * Extracted from TaskForm.js for maintainability.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Col, Button, Checkbox, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import '../../styles/index.scss';

const TaskFormActions = ({
  history,
  level,
  currentTaskId,
  buttonDisabled,
  setButtonDisabled,
  createMoreTasks,
  setCreateMoreTasks,
  handleSubmit,
}) => {
  return (
    <>
      {/* Create more tasks checkbox */}
      {(!currentTaskId || currentTaskId === 'new') && (
        <Col span={24} className="task-form-checkbox-row">
          <Checkbox
            checked={createMoreTasks}
            onChange={(e) => setCreateMoreTasks(e.target.checked)}
            className="task-form-checkbox"
          >
            Create more tasks (keep form fields after submitting)
          </Checkbox>
        </Col>
      )}

      {/* Action Buttons */}
      <Col span={24} className="task-form-actions-row">
        {level === 'PLATFORM' && (
          <Col className="task-form-back-btn-col">
            <Button
              onClick={() => history.goBack()}
              className="task-form-back-btn"
            >
              Back
            </Button>
          </Col>
        )}
        <Button
          type="primary"
          onClick={async () => {
            setButtonDisabled(true);
            try {
              await handleSubmit();
            } catch (error) {
              if (error.errorFields) {
                const errorMessages = error.errorFields
                  .map((field) => field.errors.join(', '))
                  .join(', ');
                message.destroy();
                message.error(errorMessages);
              } else {
                message.error(error.message || 'An error occurred');
              }
            } finally {
              setButtonDisabled(false);
            }
          }}
          className="task-form-submit-btn"
          disabled={buttonDisabled}
        >
          {buttonDisabled && <LoadingOutlined />}{' '}
          {currentTaskId && currentTaskId !== 'new' ? 'Update Task' : 'Create Task'}
        </Button>
      </Col>
    </>
  );
};

TaskFormActions.propTypes = {
  history: PropTypes.object.isRequired,
  level: PropTypes.string,
  currentTaskId: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  setButtonDisabled: PropTypes.func.isRequired,
  createMoreTasks: PropTypes.bool,
  setCreateMoreTasks: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

TaskFormActions.defaultProps = {
  level: null,
  currentTaskId: null,
  buttonDisabled: false,
  createMoreTasks: false,
};

export default TaskFormActions;
